/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ClienteDto interface.
 */
export function instanceOfClienteDto(value) {
    return true;
}
export function ClienteDtoFromJSON(json) {
    return ClienteDtoFromJSONTyped(json, false);
}
export function ClienteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'denominazione': json['denominazione'] == null ? undefined : json['denominazione'],
    };
}
export function ClienteDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'denominazione': value['denominazione'],
    };
}
